import { InputMask, InputMaskProps } from "primereact/inputmask";
import { useField, useFormikContext } from "formik";
import ErrorMessage from "./ErrorMessage";

interface CustomInputMaskProps extends Omit<InputMaskProps, "value" | "onChange"> {
  id: string;
  label: string;
}

const CustomInputMask = ({ id, label, ...props }: CustomInputMaskProps) => {
  const [field, meta, helpers] = useField(id);
  const formik = useFormikContext();

  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <InputMask
        id={id}
        {...field}
        {...props}
        value={field.value || ""}
        onChange={(e) => helpers.setValue(e.value)}
        className={`w-full ${meta.touched && meta.error ? "p-invalid" : ""}`}
      />
      <ErrorMessage id={id} formik={formik} />
    </div>
  );
};

export default CustomInputMask; 